export default __webpack_public_path__ + "static/media/ROOTSGOODSs.25bc1d71.png";